import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate } from '@fortawesome/free-solid-svg-icons';

interface RestorePurchasesButtonProps {}

const RestorePurchasesButton: React.FC<RestorePurchasesButtonProps> = () => {
  const [isSpinning, setIsSpinning] = useState(false);

  const handleClick = () => {
    setIsSpinning(true);
    window.ReactNativeWebView.postMessage(JSON.stringify({
      functionName: "restorePurchases",
      data: []
    }));

    // Reset the spinning state after 1 second
    setTimeout(() => setIsSpinning(false), 1000);
  };

  return (
    <button
      className="inline-flex items-center px-4 py-2 mx-auto max-w-56 bg-teal-600 dark:bg-teal-700 text-white rounded-md hover:bg-teal-500 dark:hover:bg-teal-600 transition-colors duration-200"
      onClick={handleClick}
    >
      Restore Purchases
      <FontAwesomeIcon
        icon={faRotate}
        className={`ml-2.5 h-3.5 w-3.5 transition-transform duration-1000 ${isSpinning ? 'animate-spin' : ''}`}
      />
    </button>
  );
};

export default RestorePurchasesButton;